import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Aboutus } from "./pages/Aboutus";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AcnePage from "./pages/concerns/AcnePage";
import BlackheadsPage from "./pages/concerns/BlackheadsPage";
import TanningPage from "./pages/concerns/TanningPage";
import DryskinPage from "./pages/concerns/DryskinPage";
import WrinklesPage from "./pages/concerns/WrinklesPage";
import OilyskinPage from "./pages/concerns/OilyskinPage";
import BlogsPage from "./pages/BlogsPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import NotFound from "./pages/NotFound";
import ImportantLinks from "./pages/ImportantLinks";
import FaqPage from "./pages/FaqPage";
import CategoryPage from "./pages/CategoryPage";
import PromoNavbar from "./components/PromoNavbar";
import CombosPage from "./pages/CombosPage";
import ComboDetailPage from "./pages/ComboDetailPage";
import { Imagegallery } from "./pages/Imagegallery";
import { FlipkartPage } from "./pages/FlipkartPage";
import SunscreenBarterCollaboration from "./pages/collab/SunscreenBarterCollaboration";




const App = () => {
  return (
    <Router>
      <div className="min-h-screen  flex flex-col justify-between">
        <PromoNavbar/>
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:str" element={<ProductDetail />} />
            <Route path="/combos" element={<CombosPage />} />
            <Route path="/combos/:str" element={<ComboDetailPage />} />

            {/* Concern Routes */}
            <Route path="/concerns/acne" element={<AcnePage />} />
            <Route path="/concerns/blackheads" element={<BlackheadsPage />} />
            <Route path="/concerns/tanning" element={<TanningPage />} />
            <Route path="/concerns/dry-skin" element={<DryskinPage />} />
            <Route path="/concerns/wrinkles" element={<WrinklesPage />} />
            <Route path="/concerns/oily-skin" element={<OilyskinPage />} />
            {/* Blog Routes */}
            <Route exact path="/blogs" element={<BlogsPage/>} />
            <Route exact path="/blogs/:slug" element={<BlogDetailPage/>} />

            <Route path="/category/:categorySlug" element={<CategoryPage />} />

            <Route path="*" element={<NotFound />} />
            <Route path="/links" element={<ImportantLinks/>} />
            <Route path="/images" element={<Imagegallery/>} />
            <Route path="/help/faq" element={<FaqPage/>} />

            {/* Marketplaces links */}
            <Route path="/Buy-Shinzura-From-Flipkart" element={<FlipkartPage/>} />
            <Route path="Collab/SunscreenBarterCollaboration" element={<SunscreenBarterCollaboration/>} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
